import { Component, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { animate, style, transition, trigger } from '@angular/animations';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    animations: [
        trigger('error', [
            transition(':enter', [
                style({ transform: 'translateY(-10px)' }),
                animate('100ms ease-out', style({ transform: 'none' }))
            ])
        ])
    ],
    standalone: false
})
export class ErrorComponent implements OnInit {

  @Input() control: AbstractControl;

  errorKey: string;
  errorParams: any;
  private destroyRef = inject(DestroyRef);

  constructor() {
  }

  ngOnInit(): void {
    this.getFirstErrorKey();
    this.control.statusChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(newStatus => {
        if (newStatus === 'INVALID') {
          this.getFirstErrorKey();
        }
      });
  }

  private getFirstErrorKey(): void {
    this.errorKey = this.control.errors ? Object.keys(this.control.errors)[0] : null;
    if (this.errorKey) {
      this.errorParams = this.control.errors[this.errorKey];
    }
  }
}
